<template>
  <section class="charts">
    <vue-highcharts
      :highcharts="Highcharts"
      :options="barOptions"
      ref="drilldownChart"
    ></vue-highcharts>
  </section>
</template>
<script>
import VueHighcharts from "vue2-highcharts";
import Highcharts from "highcharts";

export default {
  name: "SessionChart",
  props: ["data"],
  components: {
    VueHighcharts,
  },
  data() {
    return {
      Highcharts: Highcharts,
      barOptions: {},
      chart_categories: [],
      bookings_created: [],
      bookings_ended: []
    };
  },
  created() {
    this.formatData();    
  },
  methods: {
    formatData() {
      let data = JSON.parse(JSON.stringify(this.data));

      this.chart_categories = data.map(val => val.name);
      this.bookings_created = data.map(val => val.bookings_created);
      this.bookings_ended = data.map(val => val.bookings_ended);
      this.renderChart();
    },
    renderChart() {
      this.barOptions = {
        lang: {
          drillUpText: "back",
        },
        chart: {
          type: "column",
          backgroundColor: "transparent",
          height: 170,
          style: {
            fontFamily: '"Open Sans"',
          },
        },
        title: {
          text: "",
        },
        xAxis: {
          type: "category",
          title: {
            text: "",
          },
          categories: this.chart_categories,
          labels: {
            style: {
              color: "#fff",
              fontSize: "12px",
              fontWeight: 600,
              textDecoration: "none",
              opacity: 0.5,
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
          gridLineDashStyle: "longdash",
          gridLineWidth: 1,
          labels: {
            style: {
              color: "#fff",
              fontSize: "12px",
              fontWeight: 600,
              textDecoration: "none",
              opacity: 0.5,
            },
          },
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            borderRadius: 2,
            dataLabels: {
              enabled: false,
            },
          },
        },
        tooltip: {
          valueSuffix: "",
          shared: false,
          enabled: true,
          useHTML: true,
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
          footerFormat: '</table>'
        },
        colors: ["#F5A623","#3D550C"],
        series: [
          {
            name: 'Sessions Created',
            data: this.bookings_created

          }, 
          {
            name: 'Sessions Ended',
            data: this.bookings_ended

          }
        ]
      }
    }
  },
};
</script>
<style >
.highcharts-yaxis-grid .highcharts-grid-line {
  stroke-width: 0.5px;
  stroke: rgba(255, 255, 255, 0.1);
}
.highcharts-xaxis .highcharts-axis-line {
  display: none;
}
</style>
